import { useState } from "react";

function SaveButton({ disabled, onClick, isSaved }) {
	const [isHovered, setIsHovered] = useState(false);

	return (
		<button
			disabled={disabled}
			className="inline-flex items-center justify-center bg-gray-200! text-gray-700 h-9 rounded hover:bg-gray-300! transition-colors text-sm font-inter w-full md:w-[70px] relative overflow-hidden"
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
			onClick={onClick}
		>
			<span
				className={`transition-all duration-300 ${isHovered ? "opacity-0 transform -translate-y-8" : "opacity-100"}`}
			>
				{disabled ? "Saving..." : <>{isSaved ? <i className="fa-solid fa-bookmark" /> : "Save"}</>}
			</span>
			<span
				className={`absolute inset-0 flex items-center justify-center transition-all duration-300 ${isHovered ? "opacity-100 transform translate-y-0" : "opacity-0 transform translate-y-8"}`}
			>
				{disabled ? "Saving..." : <i className="fa-regular fa-bookmark" />}
			</span>
		</button>
	);
}

export default SaveButton;
